import type {
	DayPeriod,
	ProfileUnavailabilityRefreshPayload,
} from '@/components/modal/types';

export enum UnavailabilityType {
	FULL_DAY = 'FULL_DAY',
	CUSTOM = 'CUSTOM',
}

/** `true` means the slot stays available during the unavailability. */
export type UnavailabilitySlots = Record<DayPeriod, boolean>;

export interface ProfileUnavailabilityModalProps {
	open: boolean;
	interimId: string;
	id?: string;
	startDate?: string;
	endDate?: string;
	reason?: string;
	comment?: string;
	unavailablePeriods?: DayPeriod[];
	onPlanningRefresh?: (
		payload: ProfileUnavailabilityRefreshPayload
	) => void | Promise<void>;
	onRefresh?: (payload: ProfileUnavailabilityRefreshPayload) => void;
	onBeforeSubmit?: (
		payload: ProfileUnavailabilityRefreshPayload
	) => Promise<void>;
	onSubmitError?: (error: unknown) => void | Promise<void>;
}
